export default class compareRooms {
	constructor() {

		const maxNumberOfRooms = 4;
		const buttonsInList = document.querySelectorAll('[data-compare-list]');
		const checkboxesInForm = document.querySelectorAll('[data-compare-form]');
		let isAjaxWorking = false

		const selectedRooms = [];
		const submitButton = document.getElementById('submit-room-compare-1');
		const submitButtonCloseText = submitButton?.querySelector('.close-submit');
		const submitButtonOpenText = submitButton?.querySelector('.open-submit');

		const currentRoomInput = document.querySelector('[data-current-room-id]');


		/* If we are on a single room page include its id in the array */
		if (currentRoomInput) {
			selectedRooms.push(currentRoomInput.getAttribute('data-current-room-id'));
		}

		document.querySelector('.compare-modal .close')?.addEventListener('click', function() {
			document.body.style.overflowY = "visible";
			document.querySelector('.compare-modal').classList.add('d-none');
		})
		let storedRooms = window.localStorage.getItem('compare_rooms')

		if (storedRooms !== null) {
			let storedRoomsArray = JSON.parse(storedRooms);
			storedRoomsArray.forEach(id => {
				checkSelected(selectedRooms, id)
			})
		}

		/* Run this every time an input gets updated */
		function checkSelected(idsArray, newId) {
			/* Update array of selected roomids */
			if (idsArray.includes(newId)) {
				idsArray.splice(idsArray.indexOf(newId), 1);
			} else if (selectedRooms.length < maxNumberOfRooms) {
				idsArray.push(newId)
			}
			window.localStorage.setItem('compare_rooms', JSON.stringify(idsArray));
			/* Update fake checkboxes in room posts */
			buttonsInList.forEach(function (button) {
				if (idsArray.includes(button.getAttribute('data-compare-list'))) {
					button.classList.add('is-selected')
				} else {
					button.classList.remove('is-selected')
				}
			})

			/* Update real checkboxes in form */
			checkboxesInForm.forEach(function (box) {
				if (idsArray.includes(box.getAttribute('data-compare-form'))) {
					box.checked = true
					box.classList.add('is-selected')
				} else {
					box.checked = false
					box.classList.remove('is-selected')
				}
			});

			/* Show/Hide submit button */
			if (idsArray.length > 1) {
				submitButton?.classList.add('is-active')
			} else {
				submitButton?.classList.remove('is-active')
			}
		}

		/* Event listener for fake checkboxes in room posts */
		buttonsInList.forEach(function (button) {
			button.addEventListener('click', function () {
				const buttonId = button.getAttribute('data-compare-list')
				checkSelected(selectedRooms, buttonId)
			})
		})

		/* Event listener for real checkboxes in form */
		checkboxesInForm.forEach(function (box) {
			box.addEventListener('click', function () {
				const boxId = box.getAttribute('data-compare-form')
				checkSelected(selectedRooms, boxId)
			})
		})
		submitButton?.addEventListener('click', function (e) {
			e.preventDefault();

			const bodyOverflow = document.body.style.overflowY;
			if (bodyOverflow === "hidden") {
				document.body.style.overflowY = "visible";
				ajaxRequest(isAjaxWorking, this , false);

			}
			else {
				document.body.style.overflowY = "hidden";
				ajaxRequest(isAjaxWorking, this , true);

			}

		})
		function updateStickyDivs(roomElements, stickyDivs, modalContent) {
			let scrollOffset = 250;
			const e = modalContent.scrollTop;
			if (window.innerWidth <= 768) {
				scrollOffset = 200;
			}
			else if (window.innerWidth <= 992) {
				scrollOffset = 225;
			}

			roomElements.forEach(function(room, idx){
				if (e >= scrollOffset) {
					stickyDivs[idx].style.top = (e - scrollOffset) + "px";
				}
			})
		}

		const roomTableResponse = async (ajaxUrl = '', data = {}) => {
			let formData = new FormData();

			Object.keys(data).forEach(key => formData.append(key, data[key]));

			return fetch( ajaxUrl, {
				method: 'POST',
				body: formData,
			});
		}

		function ajaxRequest(isAjaxWorking,submitButton = this, openModal = true) {
			const btn = submitButton;

			btn.classList.add('is-loading');

			if (isAjaxWorking) return;

			isAjaxWorking = true;

			const nonce = document.querySelector('#room-compare-form #_wpnonce').value;
			const ajaxUrl = document.querySelector('#room-compare-form #wp-ajax-url').value;

			const dataObject = {
				'nonce': nonce,
				'action': 'room_compare',
				'selected_rooms': selectedRooms.join(),
			}

			if ('el' === document.documentElement.getAttribute('lang')) {
				dataObject.querylang = 'el';
			} else {
				dataObject.querylang = 'en';
			}

			function removeAllChildNodes(parent) {
				while (parent.firstChild) {
					parent.removeChild(parent.firstChild);
				}
			}

			roomTableResponse(ajaxUrl, dataObject)
			.then(res => {
				return res.json();
			})
			.then(data => {
				let roomsTable = data.rooms_table;
				let tableElement = document.createElement('span');
				tableElement.innerHTML = roomsTable;

				let modalPostContent = document.getElementById('modal-post-content');

				removeAllChildNodes(modalPostContent);
				modalPostContent.append(tableElement);
				const roomCompareModal = document.getElementById('room-compare-modal');

				if (openModal) {
					roomCompareModal.classList.remove('d-none');
					submitButtonOpenText.classList.add('d-none');
					submitButtonCloseText.classList.remove('d-none');
				} else {
					roomCompareModal.classList.toggle('d-none');
					submitButtonOpenText.classList.remove('d-none');
					submitButtonCloseText.classList.add('d-none');
				}

				const deleteButtons = document.querySelectorAll('.cell-delete');

				deleteButtons && Array.from(deleteButtons).map(elem => elem.addEventListener('click', function () {
					let cellId = elem.getAttribute('data-cell-id')
					let row = document.querySelector('.col-row[data-cell-id="' + cellId + '"]')
					let roomId = row.querySelector('.row-id').innerHTML.trim();
					if (selectedRooms.includes(roomId)) {
						selectedRooms.splice(selectedRooms.indexOf(roomId), 1)
					}

					window.localStorage.setItem('compare_rooms', JSON.stringify(selectedRooms));
					/* Update fake checkboxes in room posts */
					Array.from(buttonsInList).map((button) => {
						if (selectedRooms.includes(button.getAttribute('data-compare-list'))) {
							button.classList.add('is-selected')
						} else {
							button.classList.remove('is-selected')
						}
					});

					/* Show/Hide submit button */
					if (selectedRooms.length > 1) {
						submitButton?.classList.add('is-active')
					} else {
						submitButton?.classList.remove('is-active')

					}

					row.remove();

					let rows = document.querySelectorAll('.col-row[data-cell-id]')
					if (rows.length === 0) {
						roomCompareModal.classList.toggle('d-none');
						submitButtonOpenText.classList.remove('d-none');
						submitButtonCloseText.classList.add('d-none');
						document.body.style.overflowY = "visible";
					}

				}));

				let modalContent = document.querySelector("#room-compare-list");
				let stickyDivs = modalContent.querySelectorAll(".stickyDiv");
				let roomElements = document.querySelectorAll(".room-compare-elements");

				Array.from(roomElements).map(room => {
					room.style.marginTop = (stickyDivs[0].offsetHeight + 40) + "px";
				});

				updateStickyDivs(roomElements, stickyDivs, modalContent);

				// Make middle text width adjustable with the slides
				let selectedRoomsElement = document.querySelector('.selected-rooms');
				let widthCount = 0;

				for (const child of selectedRoomsElement.children ) {
					widthCount += child.offsetWidth;
				}

				const middleText = document.getElementById('middle-table-title');
				middleText.style.width = `${widthCount}px`;

				modalContent.addEventListener("scroll",function(){
					updateStickyDivs(roomElements, stickyDivs, modalContent);
				});

			})
			.finally(() => {
				isAjaxWorking = false;
				btn.classList.remove('is-loading')
			});
		}
	}
}
